<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-5' : 'justify-space-between'"
      class="d-flex"
    >
      <v-card-title
        class="titre-h3 mt-3 mb-3 ml-1"
      >
        Configurer le comparateur de marge 
      </v-card-title>
    </div>

    <BaseMessageServerError v-if="serverError" />
    <div>
      <BaseLoader v-if="loading" />
    </div>
    <v-card
      elevation="0"
      class="border"
    >
      <CartePrix @updatePrix="updatePrix" />
    </v-card>
    <v-row
      v-if="!loading"
      no-gutters
      class="mt-2"
    >
      <v-col
        v-for="(culture, index) in culturesSorted"
        :key="index"
        cols="12"
        class="my-1"
      > 
        <CarteCulture
          :culture-id="culture.id"
          @loading="loading"
          @updateParametre="onOpenParametreModal()"
        />
      </v-col>
      <v-col
        v-if="cultures.length"
        cols="12"
      >
        <AjoutCulture
          class="eq-height"
          @ajout-culture="onAjouteComparateurMarge"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-row no-gutters>
          <BaseCardV2
            v-if="!loading && cultures.length === 0"
            class="mt-2"
          >
            <div
              :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
              class="d-flex align-center flex-column pb-6"
            >
              <div
                :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
                class=" d-flex flex-column intro texte-gris-fonce text-align-center mt-2 text-justify mx-5"
              >
                <span class="mt-1 mb-5 text-center">Ajoutez votre première culture.</span>
                <AgrButton
                  color="primary darken-1"
                  @click="onAjouteComparateurMarge()"
                >
                  <span class="action text-truncate white--text">Ajouter une culture</span>
                </AgrButton>
              </div>
            </div>
          </BaseCardV2>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="isOpenModalAjoutCulture"
      width="500"
    >
      <AjoutCultureModal
        v-if="isOpenModalAjoutCulture"
        :cultures="cultures"
        @save="createComparateurMarge"
        @close="onCloseAjoutCulture()"
      />
    </v-dialog>
  </div>
</template>
      
<script>
import { mapActions, mapGetters } from 'vuex'
import {AgrButton} from '@agrial/ui'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import CarteCulture from './components/carte-culture.vue'
import CartePrix from './components/carte-prix.vue'
import AjoutCulture from '@/views/cultures/components/ajout-culture.vue'
import AjoutCultureModal from './components/modal/ajout-culture-modal.vue'
import { orderBy } from 'lodash'

export default {
  name: 'ComparateurMargeAdmin',
  components: { AgrButton, AjoutCulture, AjoutCultureModal, BaseCardV2, BaseLoader, BaseMessageServerError, CarteCulture, CartePrix },

  data () {
    return {
      loading: false,
      serverError: false,
      isOpenModalAjoutCulture: false
    }
  },

  computed: {
    ...mapGetters({
      cultures: 'comparateurMarge/cultures'
    }),
   
    culturesSorted () {
      return this.cultures.length ? orderBy(this.cultures, 'nom') : []
    }
  },

  created () {
    this.loadComparateurMargeCulturesPresentes()
  },

  methods: {
    ...mapActions({
      getComparateurMargeCulturesPresentes: 'comparateurMarge/getComparateurMargeCulturesPresentes',
      getAdminComparateurMargeByGraine: 'comparateurMarge/getAdminComparateurMargeByGraine'
    }),
    loadComparateurMargeCulturesPresentes () {
      this.loading = true
      this.serverError = false
      this.getComparateurMargeCulturesPresentes(true)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    onAjouteComparateurMarge () {
      this.isOpenModalAjoutCulture = true
    },
    onCloseAjoutCulture () {
      this.isOpenModalAjoutCulture = false
    },
    createComparateurMarge (typeCultureId) {
      this.loading = true
      this.serverError = false
      this.getAdminComparateurMargeByGraine(typeCultureId)
        .then(() => {
          this.getComparateurMargeCulturesPresentes(true)
            .catch(() => {
              this.serverError = true
            })
            .finally(() => {
              this.loading = false
              this.isOpenModalAjoutCulture = false

            })
        })
    },
    updatePrix () {
      this.loadComparateurMargeCulturesPresentes()
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--v-secondary-base);
}
</style>